<template>
  <div class="title_darkred">
    <h4>{{ title }}</h4>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: 'HELLO DARKRED TITLE',
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
  h4{
    color:darkred;
    margin-bottom: 30px;
  }
</style>
